import styled, { keyframes } from 'styled-components';
import Link from 'redux-first-router-link';
import * as UI from 'components/modules/UI/ui';
import { defaultProps } from 'recompose';

const footerGrow = customHeight => keyframes`
   100% {
   height: ${customHeight}px;
  }
`;

export const StyledLink = styled(Link)`
  color: ${({ color }) => color};
`;
export const TitleWrapper = styled.div`
  color: ${({ color }) => color};
`;

export const Section = styled.section`
  background-color: ${({ backgroundColor }) => backgroundColor};
  &.maxHeight {
    ${({ customHeight }) => (customHeight ? `${customHeight}px` : '100vh')};

    position: fixed;
    z-index: 20;
  }
  &.enterActive {
    position: fixed;
    z-index: 20;
    animation: ${({ customHeight }) =>
    `${footerGrow(customHeight)} 0.8s ease-out forwards`};

    & p {
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.2s ease, visibility 0.2s ease;
    }
  }
  ${({ mode, customHeight }) => {
    if (mode === 'hero') {
      return `
      position: relative;

      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;

      background-repeat: repeat, no-repeat;
      background-position: center, center;
      background-size: cover;
      height: ${customHeight ? `${customHeight}px` : '100vh'};
      `;
    } else if (mode === 'footer') {
      return ` position: absolute;
        right: 0;
        bottom: 0;
        left: 0;

        display: flex;
        align-items: center;
        height: 370px;
        @media (min-width: 1280px) and (min-height: 768px) {
         height: 445px;
      }`;
    }
  }};
  `;

export const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;

  display: block;
  overflow: hidden;
  `;
export const Video = styled.video`
  width: 100%;
  height: 100%;

  object-fit: cover;
  `;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: ${({ backgroundColor }) => backgroundColor};
  `;

export const Content = styled.div`
  position: relative;

  margin: 0;
  margin-top: 25vh;
  margin-right: ${UI.mobileSideOffset};
  margin-bottom: 20vh;
  margin-left: ${UI.mobileSideOffset};

  @media (min-width: 768px) {
    margin: auto;
    width: 62%;
    margin-right: auto;
  }

  @media (min-width: 1600px) {
    margin-left: 28.5%;
    margin-right: auto;
  }
  `;

export const Title = styled.h1`
  margin: 0;
  color: ${({ color }) => color};
  @media (min-width: 1280px) {
    text-align: center;
  }
  @media (min-width: 1600px) {
    white-space: pre-wrap;
    text-align: left;
  }
  `;



// WEBPACK FOOTER //
// ./src/components/modules/PreviewManager/styled.js